import { mount } from '../core/mount.js';
import { initialQuery } from '../core/state.js';
import data from './data.json';
import { render } from './view.js';

mount('standby', (target, config) => {
  render(target, data, config, initialQuery('standby'));
});
